export enum NotificationType {
  NEW_RSVP = "new_rsvp",
  ASO_EBI_SALE = "aso_ebi_sale",
  NEW_WELL_WISH = "new_well_wish",
}

export interface RSVPEventData {
  guestName: string;
  guestEmail: string;
  inviteStatus: string;
  rsvpComingFor: string;
  rsvpRelationship: string;
  guestId: string;
}

export interface AsoEbiSaleEventData {
  buyerName: string;
  buyerEmail: string;
  buyerPhone: string;
  items: string;
  amount: number;
  transactionId: string;
  deliveryAddress: string;
}

export interface WellWishEventData {
  authorName: string;
  wishType: string;
  message: string;
  wellWishId: string;
  creationCtx: string;
  isFreeWish: boolean;
}

export type NotificationData = RSVPEventData | AsoEbiSaleEventData | WellWishEventData;

export interface Notification {
  _id: string;
  weddingId: string;
  type: NotificationType;
  title: string;
  message: string;
  data: NotificationData;
  createdAt: string;
  expiresAt: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
}